import { useExperimentsModeContext } from '@neptune/shared/leaderboard-business-logic';

import { useCompareContext } from './use-compare-context';

export function useListOnlyAddedToggleLabel(isTristateEnabled?: boolean) {
  const { experimentsOnlyEnabled } = useExperimentsModeContext();
  const {
    filteredRunIdsCount,
    filteredExperimentNamesCount,
    filteredAddedRunIdsCount,
    filteredAddedExperimentNamesCount,
  } = useCompareContext();

  if (isTristateEnabled) {
    const addedSelectionToggleCount = experimentsOnlyEnabled
      ? filteredAddedExperimentNamesCount
      : filteredAddedRunIdsCount;

    return `List only added (${addedSelectionToggleCount})`;
  }

  const selectionToggleCount = experimentsOnlyEnabled
    ? filteredExperimentNamesCount
    : filteredRunIdsCount;

  return `Display only selected (${selectionToggleCount})`;
}
